// ===========================================
// BUSTED! BLACKJACK - TABLE THEME TYPES
// ===========================================
// Defines the theme schema for table graphics
// with optimized visual parameters.
// ===========================================
// MODAL FRAME TOKEN (Universal Modal Shell)
// ===========================================
// Single source of truth for modal frame styling.
// Used by both DOM modals (Modal.tsx) and Pixi modals (PixiHowToBetModal.ts).
export const MODAL_FRAME = {
    borderColor: { default: '#eab308', alert: '#ef4444' }, // casino-gold-500 / casino-red-500
    borderWidthPx: 2,
    radiusPx: 16, // rounded-2xl
    bodyBg: '#1f2937', // gray-800
};
/** Default glow configuration (matches Table2 theme) */
export const DEFAULT_GLOW_CONFIG = {
    blur: 3,
    r: 255,
    g: 215,
    b: 0,
    opacity: 0.4,
    color: '#FFD700',
};
/** Default chip visibility configuration (matches Table2 theme) */
export const DEFAULT_CHIP_VISIBILITY = {
    backingPlate: true,
    backingPlateOpacity: 0.6,
    backingPlateRadius: 24,
    dropShadow: true,
    dropShadowBlur: 8,
    dropShadowOffsetY: 4,
    dropShadowOpacity: 0.6,
    counterPill: true,
    counterPillOpacity: 0.9,
    counterPillFontColor: '#FB923C',
    counterPillFontSize: 10,
    outlineStroke: false,
    outlineStrokeWidth: 2,
    outlineStrokeColor: '#FFD700',
    frostedGlass: false,
    frostedGlassBlur: 4,
    bettingCircle: true,
    bettingCircleOpacity: 0.3,
    bettingCircleColor: '#FFD700',
};
/** Default beam configuration (matches Table2 theme) */
export const DEFAULT_BEAM_CONFIG = {
    width: 35,
    speed: 2.5,
    opacity: 0.5,
    color: '#22C55E',
};
/** Default seat visual configuration */
export const DEFAULT_SEAT_VISUALS = {
    seatBorderColor: '#EAB308',
    seatBorderOpacity: 70,
    seatBgColor: '#166534',
    seatBgOpacity: 40,
    usernameFontColor: '#FFFFFF',
    usernameFontSize: 12,
    scoreBoxFillColor: '#1F2937',
    scoreBoxFontColor: '#FFFFFF',
    scoreBoxFontSize: 14,
    scoreBoxBorderColor: '#374151',
    scoreBoxBorderWidth: 0,
    scoreBoxOpacity: 100,
    scoreBoxCornerRadius: 4,
    avatarBorderColor: '#FDBA74',
    avatarBorderWidth: 2,
    avatarSize: 48,
    avatarGlowColor: '#FACC15',
    avatarGlowIntensity: 50,
    turnHighlightColor: '#FACC15',
    // Dealer button (THE button)
    dealerButtonBgColor: '#FFFFFF',
    dealerButtonFontColor: '#111827',
    dealerButtonFontSize: 12,
    dealerButtonBorderWidth: 2,
    dealerButtonBorderColor: '#111827',
    dealerButtonSize: 100,
    outcomeWinColor: '#4ADE80',
    outcomeBlackjackColor: '#FACC15',
    outcomeLoseColor: '#EF4444',
    outcomeBustColor: '#EF4444',
    outcomePushColor: '#D1D5DB',
    outcomeSurrenderColor: '#FACC15',
    betAmountColor: '#FFFFFF',
};
/** Default staged chips configuration */
export const DEFAULT_STAGED_CHIPS = {
    position: { x: 0, y: 0 },
    width: 200,
    height: 64,
    label: 'Build your bet',
    labelFontSize: 14,
    borderWidth: 4,
};
/** Default shoe configuration */
export const DEFAULT_SHOE_CONFIG = {
    position: { x: 20, y: -15 },
    rotation: 90,
    scale: 140,
    cardSize: { width: 53, height: 75 },
    cards: [
        { top: 16, left: 10, rotationOffset: -5 },
        { top: 12, left: 14, rotationOffset: 0 },
        { top: 8, left: 18, rotationOffset: 5 },
    ],
    cardBackBorder: { width: 0, color: '#FFFFFF' },
};
/** Default tray configuration */
export const DEFAULT_TRAY_CONFIG = {
    position: { x: -20, y: -5 },
    rotation: 0,
    scale: 120,
    chipPositions: {
        1: { x: -44, y: 19 },
        5: { x: -30, y: 20 },
        25: { x: -16, y: 20 },
        100: { x: -2, y: 20 },
        500: { x: 12, y: 20 },
        1000: { x: 27, y: 20 },
        5000: { x: 41, y: 20 },
    },
    chipSize: 20,
};
/** Default chip label configuration */
export const DEFAULT_CHIP_LABEL_CONFIG = {
    offsetY: 0,
    fontSize: 14,
    fontColor: '#FFFFFF',
    pillOpacity: 0,
    pillColor: '#000000',
    customText: {},
};
/** Default clickable chips configuration */
export const DEFAULT_CLICKABLE_CHIPS = {
    positions: {
        1: { x: -150, y: 0 },
        5: { x: -100, y: 0 },
        25: { x: -50, y: 0 },
        100: { x: 0, y: 0 },
        500: { x: 50, y: 0 },
        1000: { x: 100, y: 0 },
        5000: { x: 150, y: 0 },
    },
    scale: 100,
    rotation: 0,
    borderWidth: 4,
    labelConfig: { ...DEFAULT_CHIP_LABEL_CONFIG },
};
/** Creates a default table theme with given ID and name */
export function createDefaultTheme(id, name) {
    return {
        id,
        name,
        chipVisibility: { ...DEFAULT_CHIP_VISIBILITY },
        glowConfig: { ...DEFAULT_GLOW_CONFIG },
        beamConfig: { ...DEFAULT_BEAM_CONFIG },
    };
}
//# sourceMappingURL=theme.js.map